import React from "react";

export default function UserAccountFormFormGroupWrapper({
  children,
  marginClass,
}: {
  children: React.ReactNode;
  marginClass?: string;
}) {
  return <div className={`${marginClass ?? "mb-5"}`}>{children}</div>;
}
